import React from 'react'
import {
  SwipeableDrawer,
  Avatar,
  Tabs,
  Tab
} from '@material-ui/core'

const TopDrawer = props => {
  return (
    <SwipeableDrawer
      anchor='top'
      open={props.drawer}
      onClose={e => props.setDrawer(false)}
      onOpen={e => props.setDrawer(true)}
      className={props.classes.drawerRoot}
    >
      <Tabs
        value={props.path}
        onChange={(e,v) => props.changeRoute(v, true)}
        className={props.classes.drawerButton}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {props.projectList.map(project => (
          <Tab
            key={project.path}
            label={project.name}
            icon={<Avatar alt={project.name} src={project.icon} />}
          />
        ))}
      </Tabs>
    </SwipeableDrawer>
  )
}

export default TopDrawer